import { PipelinePhase2q3d54imxjlma as PipelinePhase } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelinePhase.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Pipeline2vw6c5wpzxajt as Pipeline } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/Pipeline.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var PhasesClass;
function Phases() {
  if (PhasesClass === VOID) {
    class $ {
      constructor() {
        Phases_instance = this;
        this.v5j_1 = new (PipelinePhase())('Before');
        this.w5j_1 = new (PipelinePhase())('State');
        this.x5j_1 = new (PipelinePhase())('Monitoring');
        this.y5j_1 = new (PipelinePhase())('Engine');
        this.z5j_1 = new (PipelinePhase())('Receive');
      }
    }
    initMetadataForObject($, 'Phases');
    PhasesClass = $;
  }
  return PhasesClass;
}
var Phases_instance;
function Phases_getInstance() {
  if (Phases_instance === VOID)
    new (Phases())();
  return Phases_instance;
}
var HttpSendPipelineClass;
function HttpSendPipeline() {
  if (HttpSendPipelineClass === VOID) {
    class $ extends Pipeline() {
      constructor(developmentMode) {
        Phases_getInstance();
        developmentMode = developmentMode === VOID ? true : developmentMode;
        super([Phases_getInstance().v5j_1, Phases_getInstance().w5j_1, Phases_getInstance().x5j_1, Phases_getInstance().y5j_1, Phases_getInstance().z5j_1]);
        this.c5y_1 = developmentMode;
      }
      k4v() {
        return this.c5y_1;
      }
    }
    initMetadataForClass($, 'HttpSendPipeline', HttpSendPipeline, VOID, VOID, [2]);
    HttpSendPipelineClass = $;
  }
  return HttpSendPipelineClass;
}
var PhasesClass_0;
function Phases_0() {
  if (PhasesClass_0 === VOID) {
    class $ {
      constructor() {
        Phases_instance_0 = this;
        this.f5p_1 = new (PipelinePhase())('Before');
        this.g5p_1 = new (PipelinePhase())('State');
        this.h5p_1 = new (PipelinePhase())('Transform');
        this.i5p_1 = new (PipelinePhase())('Render');
        this.j5p_1 = new (PipelinePhase())('Send');
      }
    }
    initMetadataForObject($, 'Phases');
    PhasesClass_0 = $;
  }
  return PhasesClass_0;
}
var Phases_instance_0;
function Phases_getInstance_0() {
  if (Phases_instance_0 === VOID)
    new (Phases_0())();
  return Phases_instance_0;
}
var HttpRequestPipelineClass;
function HttpRequestPipeline() {
  if (HttpRequestPipelineClass === VOID) {
    class $ extends Pipeline() {
      constructor(developmentMode) {
        Phases_getInstance_0();
        developmentMode = developmentMode === VOID ? true : developmentMode;
        super([Phases_getInstance_0().f5p_1, Phases_getInstance_0().g5p_1, Phases_getInstance_0().h5p_1, Phases_getInstance_0().i5p_1, Phases_getInstance_0().j5p_1]);
        this.k5y_1 = developmentMode;
      }
      k4v() {
        return this.k5y_1;
      }
    }
    initMetadataForClass($, 'HttpRequestPipeline', HttpRequestPipeline, VOID, VOID, [2]);
    HttpRequestPipelineClass = $;
  }
  return HttpRequestPipelineClass;
}
//region block: exports
export {
  Phases_getInstance_0 as Phases_getInstance1dciif7svdqxc,
  Phases_getInstance as Phases_getInstance2rx62p874ogj4,
  HttpRequestPipeline as HttpRequestPipeline1v7xct5dgezuy,
  HttpSendPipeline as HttpSendPipeline3tm1hram7cjxt,
};
//endregion

//# sourceMappingURL=HttpRequestPipeline.mjs.map
